// extracted by mini-css-extract-plugin
module.exports = {"cellCenter":"TableHead_cellCenter__22Vee"};